export default __webpack_public_path__ + "static/media/logo_app.577d14f7.png";